import React from 'react';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  variant?: 'primary' | 'white';
  className?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ size = 'lg', variant = 'primary', className = '' }) => {
  const sizeClasses = {
    sm: 'h-5 w-5 border-2',
    md: 'h-8 w-8 border-3',
    lg: 'h-16 w-16 border-4'
  };

  const colorClasses = {
    primary: 'border-gray-200 border-t-primary',
    white: 'border-white/30 border-t-white'
  };

  const spinner = (
    <div className={`animate-spin rounded-full ${sizeClasses[size]} ${colorClasses[variant]} ${className}`}></div>
  );

  if (size === 'sm') {
    return spinner;
  }

  return (
    <div className={`flex justify-center items-center ${size === 'lg' ? 'py-20' : 'py-4'}`}>
      {spinner}
    </div>
  );
};

export default LoadingSpinner;